// Curated Google reviews for the homepage carousel.
//
// HOW TO POPULATE — 10 minutes, one-time job:
// ─────────────────────────────────────────────────────────────────────────────
// 1. Open your Google Business Profile in a new tab — sign in at
//    https://business.google.com (or open the listing on Google Maps and
//    tap "Reviews").
// 2. Pick your 6–8 STRONGEST reviews — ideally ones that:
//      • Mention a suburb ("Glenelg", "Norwood" — boosts local SEO)
//      • Mention what you fixed ("NBN modem", "data recovery", "office network")
//      • Are full sentences (not just "Great service, thanks Tom" — too short)
//      • Mix residential AND business
// 3. For each review, copy 3 things into the array below:
//      a. The customer name as shown on Google (first name + last-initial is fine)
//      b. The full review text (keep punctuation, edit only obvious typos)
//      c. The star rating (almost always 5)
// 4. Save. The carousel auto-renders on the homepage when there are >= MIN_REVIEWS.
//
// Tips:
//   • You can also include the suburb separately ("Glenelg") for the chip overlay.
//   • Date is optional — only useful if you want to show "2 weeks ago" style chips.
//   • "Tom" / "Lee" etc — putting the tech's name shows a real human did the work.

import { GOOGLE_LISTING_URL } from "./content";

export const MIN_REVIEWS_TO_SHOW = 4;

export const SUMMARY = {
  rating: "5.0",
  total: 61, // Total Google review count — update this number as it grows.
  url: GOOGLE_LISTING_URL,
};

export const reviews = [
  {
    name: "Joe F.",
    rating: 5,
    tech: "Tom",
    text:
      "I have used Tom's services for over 10 years and he has always fixed my Internet and IT issues. Tom is very thorough and helpful and knows everything! Very professional service and always happy to help me and my family.",
    date: "2026-02-15",
  },
  {
    name: "Bam Bam",
    rating: 5,
    tech: "Tom",
    text:
      "I have been using Tom for my small business tech for some years and I highly recommend — he has gone above and beyond many times. I will continue to use Tech Emergency as service and expertise is exceptional.",
    date: "2026-02-15",
  },
  {
    name: "Sonia G.",
    rating: 5,
    suburb: "Tea Tree Gully",
    tech: "Tom",
    text:
      "Tom has helped us with many computer issues over the years at work and home. Always prompt and friendly service, everything is explained well and nothing is too much trouble. I highly recommend him.",
    date: "2026-02-15",
  },
  {
    name: "Verna R.",
    rating: 5,
    tech: "Tom",
    text:
      "Tom arrived after hours to fix my printer. It hadn't talked to my computer for a long time. Now it is working better than when I first had it installed! Tom was most polite and efficient and set up icons in the Dock to make using my printer much easier. Can't thank him enough. Cheers Tom, see you again.",
    date: "2026-03-15",
  },
  {
    name: "Tragic Clipz",
    rating: 5,
    tech: "Tom",
    text:
      "Excellent service by Tom helping us sort out our issue with our email security — he went above and beyond to make sure all our security settings were up to date. Tom will be our go to guy for any future IT issues. Highly recommend.",
    date: "2026-02-15",
  },
];
